import React, { Component } from 'react'
import { Icon } from 'semantic-ui-react'

import { connect } from 'react-redux'
import * as actionCreators from '../actions'
import { formatMoney } from '../../util'



class UserFees extends Component {
  constructor() {
    super()
  }


  render() {
    let {
      hmf,
      mpf,
      fee,
      duty,
      grandTotal,
      tax,
      objectWithEverything,
      additionalDuties,
      bondedAdDutyAmt,
      bondedCvdDutyAmt,
      cashAdDutyAmt,
      cashCvdDutyAmt,
      userFees,
      drawerIsOpen,
      toggleDrawerOpen,
      other
    } = this.props

    /*additionalDuties
    userFees[{
dutyType: "COTTON_FEE"
feeValue: "50.0"
}]
*/
    // console.log('additionalDuties: ', additionalDuties);

    bondedAdDutyAmt=bondedAdDutyAmt?bondedAdDutyAmt:"0.00";
    bondedCvdDutyAmt=bondedCvdDutyAmt?bondedCvdDutyAmt:"0.00";
    cashAdDutyAmt=cashAdDutyAmt?cashAdDutyAmt:"0.00";
    cashCvdDutyAmt=cashCvdDutyAmt?cashCvdDutyAmt:"0.00";
    return (
      <div 
      onClick={() => toggleDrawerOpen()}
      className={"userfees_wr " +  (drawerIsOpen?' draweropen ':' drawerclosed ')}>
        
        <div className="drawerToggleButton">
          
          <Icon name='angle up' />

        </div>
          <br className="unimportant"/>
          <div className="feeswidth">
            <table><tbody>
              <tr className="unimportant">
                <td><b>Cash AD Amount</b></td>
                <td><b>Cash CVD Amount</b></td>
                <td><b>Bonded AD Amount</b></td>
                <td><b>Bonded CVD Amount</b></td>
              </tr>
              <tr className="unimportant darkrow">
                <td className="moneyDisplay">{formatMoney(cashAdDutyAmt)}</td>
                <td className="moneyDisplay">{formatMoney(cashCvdDutyAmt)}</td>
                <td className="moneyDisplay">{formatMoney(bondedAdDutyAmt)}</td>
                <td className="moneyDisplay">{formatMoney(bondedCvdDutyAmt)}</td>
                </tr>
            </tbody></table>
            <br className="unimportant"/>

            <div className="leftcol_fees">


              <table><tbody>
                  <tr className="unimportant  nobordersx"><td colSpan="2"><b>OTHER FEE SUMMARY</b></td></tr>
                  {mpf && 
                  <tr className="unimportant">
                    <td><b>MPF</b></td>
                    <td className="moneyDisplay">{formatMoney(mpf.fee)}</td>
                  </tr>
                  }
                  {hmf && 
                    <tr className="unimportant">
                    <td><b>HMF</b></td>
                    <td className="moneyDisplay">{formatMoney(hmf.fee)}</td>
                    </tr>
                  }
                  {cashAdDutyAmt!= "0.00" &&
                    <tr className="unimportant">
                    <td><b>AD</b></td>
                    <td className="moneyDisplay">{formatMoney(cashAdDutyAmt)}</td>
                    </tr>
                  }
                  {cashCvdDutyAmt != "0.00" &&
                    <tr className="unimportant">
                    <td><b>CVD</b></td>
                    <td className="moneyDisplay">{formatMoney(cashCvdDutyAmt)}</td>
                    </tr>
                  }
                  
                {userFees && 
                  userFees.map((userFee,index) => {
                    if(userFee.disclaim!='1' && userFee.dutyType){
                      return (
                        <tr className="unimportant" id={userFee.dutyType + '-total'} key={userFee.dutyType+"xxxx"+index}>
                          <td><b>{userFee.dutyType && userFee.dutyType.replace('_', ' ')}</b></td>
                          <td className="moneyDisplay">{formatMoney(userFee.feeValue)}
                          </td>
                        </tr>
                    )
                  }
                })
                }
                </tbody></table>

            </div>
            <div className="rightcol_fees">
              <table><tbody>
                  <tr className="unimportant  nobordersx"><td colSpan="2"><b>TOTALS</b></td></tr>
                
                  <tr className="unimportant">
                    <td><b>DUTY</b></td>
                    <td className="moneyDisplay">{formatMoney(duty)}</td>
                  </tr>
                  <tr className="unimportant">
                    <td><b>TAX</b></td>
                    <td className="moneyDisplay">{formatMoney(tax)}</td>
                  </tr>
                  <tr className="unimportant">
                    <td><b>OTHER</b></td>
                    <td className="moneyDisplay">{formatMoney(other)}</td>
                  </tr>
                  <tr  className="grandtotal nobordersx">
                    <td>
                      <div>
                          GRAND&nbsp;TOTAL
                      </div>
                    </td>
                    <td className="moneyDisplay">
                      <div>
                        {formatMoney(grandTotal)}
                      </div>
                    </td>
                  </tr>
                  
                </tbody></table>
            </div>
          </div>
        
      </div>
    )
  }
}

const mapStateToProps = (state, props) => ({
  totalEnteredValue: state.DescriptionOfMerchandise.totalEnteredValue,
  // totalLineItemWeight: state.DescriptionOfMerchandise.totalLineItemWeight,
  descriptionOfMerchandiseValues: state.DescriptionOfMerchandise,
  grossWeightWeight: state.DescriptionOfMerchandise.grossWeight.weight,
  grossWeightWeightUnits:
    state.DescriptionOfMerchandise.grossWeight.weightUnits,
  manifestQuantityQuantity:
    state.DescriptionOfMerchandise.manifestQuantity.quantity,
  manifestQuantityUnits: state.DescriptionOfMerchandise.manifestQuantity.units,
  manufacturerId: state.DescriptionOfMerchandise.manufacturerId,
  duty: state.DescriptionOfMerchandise.duty,
  grandTotal: state.DescriptionOfMerchandise.grandTotal,
  objectWithEverything: state.DescriptionOfMerchandise,
  fee: state.DescriptionOfMerchandise.fee,
  tax: state.DescriptionOfMerchandise.tax,
  hmf: state.DescriptionOfMerchandise.hmf,
  mpf: state.DescriptionOfMerchandise.mpf,
  other: state.DescriptionOfMerchandise.other,
  additionalDuties: state.DescriptionOfMerchandise.additionalDuties,
  bondedAdDutyAmt: state.DescriptionOfMerchandise.bondedAdDutyAmt,
  bondedCvdDutyAmt: state.DescriptionOfMerchandise.bondedCvdDutyAmt,
  cashAdDutyAmt: state.DescriptionOfMerchandise.cashAdDutyAmt,
  cashCvdDutyAmt: state.DescriptionOfMerchandise.cashCvdDutyAmt,
  userFees: state.DescriptionOfMerchandise.additionalDuties.userFees,
  exporttDateEpoch: state.DescriptionOfMerchandise.exportDate.epochs,
  weightUnitsList: state.DropDownValues.weightUnitsList,
  unitList: state.DropDownValues.unitList,
  totalValue: state.DescriptionOfMerchandise.totalValue,
  USStatesList: state.DropDownValues.USStatesList,
  newValue: state.FormValues.newValue,
  fieldName: state.FormValues.fieldName,
  setINPUTID: state.FormValues.setINPUTID,
  penClicked: state.FormValues.penClicked,
  shipmentId: state.FormValues.shipmentId,
  rbCounterID: state.FormValues.rbCounterID,
  formDisabled: state.FormValues.formDisabled,
  usStateOfDestCode: state.Importer.usStateOfDestCode,
  related: state.Importer.related
})

const mapDispatchToProps = {
  ...actionCreators
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(UserFees)
